// Environment Configuration
const HOST = process.env.REACT_APP_HOST || "localhost";
const NODE_SERVER_PORT = process.env.REACT_APP_NODE_SERVER_PORT || "5000";
const PYTHON_SERVICE_PORT = process.env.REACT_APP_PYTHON_SERVICE_PORT || "5001";
const ADMIN_PANEL_PORT = process.env.REACT_APP_ADMIN_PANEL_PORT || "3001";
const WEB_APP_PORT = process.env.REACT_APP_WEB_APP_PORT || "3000";

// Protocol Configuration
const PROTOCOL = process.env.REACT_APP_PROTOCOL || "http";

// Base URL Construction
const BASE_URL = `${PROTOCOL}://${HOST}:${NODE_SERVER_PORT}`;
const API_BASE_URL = `${BASE_URL}/api`;
const FACE_SWAP_URL = `${BASE_URL}/faceswap`;

// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || BASE_URL,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || API_BASE_URL,
  FACE_SWAP_URL: process.env.REACT_APP_FACE_SWAP_URL || FACE_SWAP_URL,

  // Endpoints
  ENDPOINTS: {
    AUTH: "/auth",
    DEVICES: "/devices",
    USERS: "/users",
    ANALYTICS: "/analytics",
    HEALTH: "/health",
    VERSIONS: "/versions",
    HTML_CONTENT: "/html-content",
  },

  // Timeouts
  TIMEOUTS: {
    DEFAULT: 30000, // 30 seconds
    UPLOAD: 120000, // 2 minutes
  },
};

// Port Configuration
export const PORTS = {
  ADMIN_PANEL: parseInt(ADMIN_PANEL_PORT),
  NODE_SERVER: parseInt(NODE_SERVER_PORT),
  PYTHON_SERVICE: parseInt(PYTHON_SERVICE_PORT),
  WEB_APP: parseInt(WEB_APP_PORT),
};

// Service URLs - All constructed from environment variables
export const SERVICE_URLS = {
  ADMIN_PANEL: `${PROTOCOL}://${HOST}:${ADMIN_PANEL_PORT}`,
  NODE_SERVER: `${PROTOCOL}://${HOST}:${NODE_SERVER_PORT}`,
  PYTHON_SERVICE: `${PROTOCOL}://${HOST}:${PYTHON_SERVICE_PORT}`,
  WEB_APP: `${PROTOCOL}://${HOST}:${WEB_APP_PORT}`,
};

export const config = {
  apiUrl: API_CONFIG.BASE_URL,
  apiBaseUrl: API_CONFIG.API_BASE_URL,
  faceSwapUrl: API_CONFIG.FACE_SWAP_URL,
  appName: process.env.REACT_APP_NAME || "Face Swap Admin Panel",
  appVersion: process.env.REACT_APP_VERSION || "1.0.0",
  isDevelopment: process.env.NODE_ENV === "development",
  isProduction: process.env.NODE_ENV === "production",
};

export default config;
